<div class="container-fluid px-5 d-flex align-items-center" style="height: 100%;">
    <a>{{ currentYear }} - {{ 'AllRightsReserved' | translate }}</a>
</div>
